import './Spinner.css';

import React from 'react';
import {IconSize} from "../services/IconConstants";
import LoadingIcon from "../icons/LoadingIcon";

interface Props {
    onBackground?: boolean
}

const Spinner = ({onBackground = false}: Props) => {

    let colour = 'var(--text-on-primary)'
    if (onBackground) {
        colour = 'var(--colour-neutral-200)'
    }

    return (
        <LoadingIcon size={IconSize.md} className={"loadingSpinner"} style={{
            color: colour
        }}/>
    )
}

export default Spinner;